import { PaymentFormField, PaymentFormSchema } from '@cashier/cashier-model';

import { SchemaCollectorContext } from './schemaCollector/model';
import { GeneralSchemaCollector } from './schemaCollector';

export const FormSchemaFactory = {
  create: (
    fields: PaymentFormField[],
    context: SchemaCollectorContext,
  ): PaymentFormSchema => {
    const formSchema: PaymentFormSchema = {
      staticData: {},
      cardData: null,
      commonFieldMap: null,
    };

    fields.forEach((field) => {
      GeneralSchemaCollector.collect(formSchema, field, context);
    });

    return formSchema;
  },
};
